export default __webpack_public_path__ + "static/media/slider.af8eecbb.png";